module.exports = __webpack_public_path__ + "static/media/incrowd4.76259271.gif";